/**
 * Shared, pure validation helpers built on the schema constants.
 *
 * These are deliberately small and side-effect free so they can run unchanged
 * in the browser (client-side form validation) and in Lambda (authoritative
 * server-side validation).
 */
import { EMAIL_PATTERN, FIELD_LIMITS, IMAGE_UPLOAD, ISO_DATE_PATTERN, } from "./constraints.js";
/** Returns true iff `value` is a syntactically valid email address. */
export function isValidEmail(value) {
    return EMAIL_PATTERN.test(value);
}
/** Returns true iff `value` is a well-formed ISO calendar date (YYYY-MM-DD). */
export function isIsoDate(value) {
    if (!ISO_DATE_PATTERN.test(value)) {
        return false;
    }
    // Reject things like 2025-13-40 that match the shape but aren't real dates.
    const [year, month, day] = value.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return (date.getUTCFullYear() === year &&
        date.getUTCMonth() === month - 1 &&
        date.getUTCDate() === day);
}
/** Returns true iff `value` is within the configured limit for `field`. */
export function isWithinLimit(field, value) {
    return value.length <= FIELD_LIMITS[field];
}
/** Returns true iff `contentType` is in the supported-format allowlist. */
export function isSupportedImageFormat(contentType) {
    return IMAGE_UPLOAD.supportedFormats.includes(contentType);
}
/** Returns true iff `sizeBytes` is within the configured maximum. */
export function isWithinMaxImageSize(sizeBytes) {
    return (Number.isFinite(sizeBytes) &&
        sizeBytes >= 0 &&
        sizeBytes <= IMAGE_UPLOAD.maxSizeBytes);
}
//# sourceMappingURL=validators.js.map